import CryptoJS from 'crypto-js';

/**
 * 使用 SHA256 对密码进行加密
 * @param password 原始密码
 * @returns 加密后的密码字符串
 */
export const encryptWithSha256 = (password: string): string => {
  return CryptoJS.SHA256(password).toString(CryptoJS.enc.Hex);
};